<template>
	<Modal
		ref="loginWallModal"
		modal-name="LoginWallModal"
		type="dialog"
		class="login-wall-modal"
		:theme="$arenaConfig.isLightTheme ? 'light' : 'dark'"
		:closeable="closable"
		@opened="handleOpen"
	>
		<template #title>
			{{ title }}
		</template>
		<template #content>
			{{ text }}
		</template>
		<template #footer>
			<div
				v-if="!$Helpers.isSmartTV()"
				class="l-button-group"
			>
				<Button
					v-if="computedBackUrl || closable"
					:text="closable ? $Helpers.ucfirst($I18n.trans('commons.close')) : $Helpers.ucfirst($I18n.trans('commons.back'))"
					:theme="$arenaConfig.isLightTheme ? 'light' : 'dark'"
					modifier="secondary"
					@click="closable ? closeModal() : back()"
				/>
				<Button
					:text="$I18n.trans('arena.login.error_page.button')"
					:theme="$arenaConfig.isLightTheme ? 'light' : 'dark'"
					@click="openLoginModal()"
				/>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from '@shared/components/Modal';
import Button from '@shared/components/Button';

export default {
	name:       'LoginWallModal',
	components: { Modal, Button },
	props:      {},
	data() {
		return {
			closable: false,
			title:    $I18n.trans('arena.feature_access.login_wall.title'),
			text:     $I18n.trans('arena.feature_access.login_wall.text'),
		};
	},
	computed: {
		computedBackUrl() {
			return this.backUrl || $Helpers.getBackUrl();
		},
	},
	methods: {
		back() {
			window.location.href = this.computedBackUrl;
		},
		openLoginModal() {
			this.eventBus.$emit('modal:LoginModal');
		},
		handleOpen(passedData) {
			if (passedData?.closable) {
				this.closable = true;
			}
			if (passedData?.title) {
				this.title = passedData.title;
			}
			if (passedData?.text) {
				this.text = passedData.text;
			}
		},
		closeModal() {
			this.$refs.loginWallModal.closeModal();
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

</style>
